import { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { UseI18n } from '../../../../../common/hooks/useI18n'
import { Element } from '../../../../../common/html/element'
import { Loading } from '../../../../../common/loading'
import { PopupAction } from '../../../../../common/popup/PopupAction'
import { ScrollComponent } from '../../../../../common/scrollComponent'
import EventEmitter, {
  SHOW_POPUP_ERROR,
} from '../../../../../helpers/EventEmitter'
import { debounce } from '../../../../../helpers/common'
import { Input } from '../../../../../library/common/html/input'
import {
  selectDataRawTable,
  selectLoadingDataRawPortfolio,
} from '../../store/slice'
import { getSearchPortfolio } from '../../store/thunk'
import { CreatePortfolio } from './CreatePortfolio'
import ItemCheckBox from './ItemCheckBox'

export const PopupCopyCompany = ({
  isShow,
  setShow,
  handleApply,
  numberCompany,
}) => {
  const dispatch = useDispatch()

  const data = useSelector(selectDataRawTable)
  const loadingSearch = useSelector(selectLoadingDataRawPortfolio)

  const [listCheck, setListCheck] = useState([])
  const [textSearch, setTextSearch] = useState('')
  const [isShowCreateForm, setIsShowCreateForm] = useState(false)

  const textValidate = UseI18n('library.main.VALIDATE_COMPANY')

  const height = useMemo(
    () => (data.length < 14 ? 36 * data.length : 400),
    [data.length],
  )

  const handleChangeText = useCallback(
    debounce((value) => {
      dispatch(
        getSearchPortfolio({
          InputSearch: value,
          Page: 1,
          PageSize: 300,
        }),
      )
    }, 700),
    [],
  )

  const handleAfterCreate = () => {
    dispatch(
      getSearchPortfolio({
        InputSearch: '',
        Page: 1,
        PageSize: 300,
      }),
    )
    setTextSearch('')
  }

  const showErrorMaxSize = () => {
    EventEmitter.dispatch(SHOW_POPUP_ERROR, {
      messages: [textValidate],
    })
  }

  useEffect(() => {
    handleChangeText(textSearch)
  }, [textSearch])

  return (
    <>
      {isShow && (
        <PopupAction
          isShow={isShow}
          title={'library.detailsPortfolios.TEXT_COPY_TO_PORTFOLIO'}
          handleClose={() => setShow(false)}
          btnSubmit={{
            label: 'library.filterSetting.APPLY',
            isI18n: true,
            event: (e) => {
              e.stopPropagation()
              handleApply(listCheck)
            },
            disabled: !listCheck?.length,
          }}
          btnCancel={{
            label: 'library.filterSetting.CANCEL',
            isI18n: true,
            event: (e) => {
              e.stopPropagation()
              setShow(false)
            },
          }}
        >
          <div>
            <div
              style={{ paddingBottom: 12 }}
              className="dFlex cursorPointer alignItemsCenter"
            >
              <Input
                containerStyle={{
                  flex: 1,
                  height: '28px',
                }}
                placeHolder="library.savePortfolio.SEARCH_PORTFOLIO"
                type="text"
                isSearch
                value={textSearch}
                onChange={setTextSearch}
              />
              <Element
                elementName="p"
                style={{ color: '#2C73E8', paddingLeft: 12 }}
                onClick={() => setIsShowCreateForm(true)}
              >
                <Translate value="library.savePortfolio.CREATE_NEW_PORTFOLIO" />
              </Element>
            </div>
            {(!!data.length || loadingSearch) && (
              <Element
                style={{
                  height: height,
                  backgroundColor: '#FFFFFF',
                  position: 'relative',
                }}
              >
                {loadingSearch ? (
                  <Loading />
                ) : (
                  <ScrollComponent>
                    <div
                      style={{
                        padding: '10px 12px',
                      }}
                    >
                      {data.map((item) => (
                        <ItemCheckBox
                          key={item.portfolioId}
                          item={item}
                          setListCheck={setListCheck}
                          listCheck={listCheck}
                          showError={showErrorMaxSize}
                          numberCompany={numberCompany}
                        />
                      ))}
                    </div>
                  </ScrollComponent>
                )}
              </Element>
            )}
          </div>
        </PopupAction>
      )}
      {isShowCreateForm && (
        <CreatePortfolio
          isShow={isShowCreateForm}
          setShow={setIsShowCreateForm}
          handleAfterCreate={handleAfterCreate}
        />
      )}
    </>
  )
}

export default PopupCopyCompany
